import { useState, useEffect } from "react";
import "../Styles/NextMatch.css";
import { useConfig } from "../../context/ConfigContext";

export default function NextMatchTab() {
  const { config } = useConfig();
  const API_KEY = config.REACT_APP_API_KEY;
  const GET_URL = config.REACT_APP_GET_MATCH_URL;        // /api/getnextmatch
  const UPDATE_URL = config.REACT_APP_UPDATE_MATCH_URL;  // /api/updatenextmatch

  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [openSection, setOpenSection] = useState("form"); 

  const toggleSection = (name) => {
    setOpenSection((prev) => (prev === name ? null : name));
  };


  // Load from MongoDB
  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(GET_URL, {
          headers: { "Api-Key": API_KEY }, credentials: "include"
        });

        const data = await res.json();

        setForm({
          date: data.date || "",
          kickoff: data.kickoff || data.Kickoff || "",
          venue: data.venue || data.Venue || "",
          teams: data.teams || data.Teams || "",
          address: data.address || data.Address || "",
          timeline: data.timeline || []
        });

      } catch (err) {
        console.error(err);
        setMessage("Failed to load match info");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [API_KEY, GET_URL]);

  // Update helpers
  const update = (key, val) => {
    setForm((f) => ({ ...f, [key]: val }));
  }

  const changeRow = (idx, key, val) =>
    setForm((f) => ({
      ...f,
      timeline: f.timeline.map((r, i) =>
        i === idx ? { ...r, [key]: val } : r
      )
    }));

  const addRow = () =>
    setForm((f) => ({
      ...f,
      timeline: [...f.timeline, { time: "", label: "" }]
    }));

  const delRow = (idx) =>
    setForm((f) => ({
      ...f,
      timeline: f.timeline.filter((_, i) => i !== idx)
    }));

  // Save to MongoDB
  const saveToDB = async () => {
    setMessage("");

      const newTimeline = form.timeline.filter(e => e.time !== "" && e.label !== "")
      const newForm = {
        date: form.date,
        kickoff: form.kickoff,
        venue: form.venue,
        teams: form.teams,
        address: form.address,
        timeline: newTimeline
      }
      try {

      const res = await fetch(UPDATE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Api-Key": API_KEY,
        },
        credentials: "include",
        body: JSON.stringify(newForm)
      });

      const result = await res.json();

      if (!res.ok) throw new Error(result.error);

      setMessage("Match info saved!");
    } catch(err) {
      setMessage("Failed to save match info");
      console.log(err)
    }
  };

  if (loading || !form) {
    return <p className="muted">Loading match info…</p>;
  }

  return (
    <div className="match-wrapper">
    <div className="card-grid">
      <section className="card">
        <h2 className="dropdown-header" onClick={() => toggleSection("form")}>
          🏉 Edit Next Match
            <span className={`chevron ${openSection === "form" ? "open" : ""}`}>
              ▼
              </span>
          </h2>
          {openSection === "form" && (
            <div className="form-grid">
          <label>
            <span>Date</span>
            <input
              className="input-info"
              value={form.date}
              onChange={(e) => update("date", e.target.value)}
            />
          </label>

          <label>
            <span>Kick-off</span>
            <input
              className="input-info"
              value={form.kickoff}
              onChange={(e) => update("kickoff", e.target.value)}
            />
          </label>

          <label>
            <span>Venue</span>
            <input
              className="input-info"
              value={form.venue}
              onChange={(e) => update("venue", e.target.value)}
            />
          </label>

          <label>
            <span>Teams</span>
            <input
              className="input-info"
              value={form.teams}
              onChange={(e) => update("teams", e.target.value)}
            />
          </label>

          <label>
            <span>Location</span>
            <input
              className="input-info"
              value={form.address}
              onChange={(e) => update("address", e.target.value)}
            />
          </label>
          <button className="btn-save primary" onClick={saveToDB}>
          Save to Server
          </button>
        </div>
          )}
      </section>

      <section className="card">
        
        <h2 className="dropdown-header" onClick={() => toggleSection("timeline")}>
          🕓 Timeline
          <span className={`chevron ${openSection === "timeline" ? "open" : ""}`}>
              ▼
              </span>
          </h2>

          {openSection === "timeline" && (
            <div className="timeline-scroll">
          {form.timeline.map((row, idx) => (
            <div className="timeline-row" key={idx}>
              <input
                className="time-input"
                placeholder="HH:MM"
                value={row.time}
                onChange={(e) => changeRow(idx, "time", e.target.value)}
              />
              <input
                className="label-input"
                placeholder="Event description"
                value={row.label}
                onChange={(e) => changeRow(idx, "label", e.target.value)}
              />
              <button
                className="timeline-delete"
                onClick={() => delRow(idx)}
              >
                ✕
              </button>
            </div>
          ))}
          <button className="btn-addrow" onClick={addRow}>+ Add Row</button>
          <button className="btn-save primary" onClick={saveToDB}>
          Save to Server
          </button>
        </div>
          )}
      </section>

      {message && <p className="muted small">{message}</p>}
    </div>
    </div>
  );
}